import styled from 'styled-components';

export const MobileHistoryTransactionStatusInfoStyled = styled.div`
    padding: 16px;
    background: var(--color-neutral-20);
    width: 100%;
    border-radius: 16px;
    
    .title {
        font-size: 16px;
        line-height: 24px;
    }
    
    .description {
        color: var(--color-white-60);
    }
    
    &.positive {
        background: var(--color-green-secondary-20);
    }
    &.negative {
        background: var(--color-negative-secondary-20);
    }
`;
